import { ErrorResponseBody, ValidationErrorResponseBody } from "./clients";

/**
 * 共通エラークラス
 */
export class BaseError {
  public readonly name: string;
  public readonly message?: string;

  constructor(message?: string) {
    this.name = new.target.name;
    this.message = message;
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

/**
 * エラーレスポンス例外
 */
export class ApiResponseError extends BaseError {
  public readonly message: string;

  public readonly errors: { code: string; message: string }[];

  public readonly status: number;

  constructor(body: ErrorResponseBody, status: number) {
    super(body.message);

    this.message = body.message;
    this.errors = body.errors;
    this.status = status;
  }
}

/**
 * バリデーションエラー例外
 */
export class ApiValidationError extends BaseError {
  public readonly message: string;

  public readonly errors: ValidationErrors;

  constructor(body: ValidationErrorResponseBody) {
    super(body.message);

    this.message = body.message;
    this.errors = body.errors;
  }
}

/**
 * バリデーションエラー一覧
 */
export interface ValidationErrors {
  [key: string]: string[];
}

export function getFields<DTO>(errors: ValidationErrors): (keyof DTO)[] {
  return Object.keys(errors) as (keyof DTO)[];
}

/**
 * コネクションエラー例外
 */
export class ApiConnectionError<T> extends BaseError {
  public readonly response: T | undefined;

  constructor(response: T | undefined = undefined) {
    super();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    this.response = response;
  }
}
